import Link from "next/link";

const Story = ({ compFor }) => {
  if (compFor === "about") {
    return (
      <div>
        <section className="dark:bg-jacarta-1100 bg-jacarta-1100 relative py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>

          <div className="container">
            <div className="lg:flex lg:justify-between ">
              {/* <!-- Image --> */}
              <div className="lg:w-[55%] self-center">
                <div className="relative self-center">
                  <img
                    src="/images/about/about-cirsys-2.png"
                    width="200"
                    height="200"
                    className="mx-auto mt-8 w-[80%] rotate-[0deg] rounded-[2rem]"
                  />

                </div>
              </div>

              {/* <!-- Info --> */}
              <div className="py-20 lg:w-[45%] lg:pl-16">
                <h2 className="font-display mb-6 text-2xl dark:text-white text-white">
                  Acerca de CIRSYS
                </h2>
                <p className="dark:text-jacarta-300 text-jacarta-300 mb-8 text-lg leading-normal">
                  En CIRSYS buscamos crear tecnología para un mundo más sostenible. Somos una empresa que aporta valor a los negocios desarrollando proyectos con Inteligencia Artificial, Robotica Social, Automatización, desarrollo de Hardware y Software.
                </p>
                <div className="flex-col">

                  <div className="flex my-4">
                    <svg className="fill-accent h-6 w-6 shrink-0">
                      <use xlinkHref={`/icons.svg#bulb`}></use>
                    </svg>
                    <div>
                      <span className="font-display block text-xl dark:text-white text-white ml-4">
                        Innovación
                      </span>
                    </div>
                  </div>

                  <div className="flex my-4">
                    <svg className="fill-accent h-6 w-6 shrink-0">
                      <use xlinkHref={`/icons.svg#shield`}></use>
                    </svg>
                    <div>
                      <span className="font-display block text-xl dark:text-white text-white ml-4">
                        Confianza
                      </span>
                    </div>
                  </div>

                  <div className="flex my-4 mb-10">
                    <svg className="fill-accent h-6 w-6 shrink-0">
                      <use xlinkHref={`/icons.svg#intersect`}></use>
                    </svg>
                    <div>
                      <span className="font-display block text-xl dark:text-white text-white ml-4">
                        Experiencia
                      </span>
                    </div>
                  </div>

                </div>
                <Link href="/contacto">
                <a className="dark:text-jacarta-300 text-jacarta-300  mb-8 text-md leading-normal dark:hover:text-accent-dark hover:text-accent-dark group ease-out duration-200 ">
                  ¿Quieres desarrollar un proyecto?<span className="dark:text-accent text-accent dark:group-hover:text-accent-dark group-hover:text-accent-dark ease-out duration-200"> Conversemos</span>
                </a>
              </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  } else {
    return (
      <></>
    );
  }
};

export default Story;
